import { useReducer } from "react";

const send = (socket, jMessage) => {
  delete jMessage.read;
  var p = JSON.stringify(jMessage);
  socket !== undefined && socket.readyState === 1
    ? socket.send(p)
    : console.log("socket not connected");
};

const connect = (url, onopen, onclose, onerror, onmessage) => {
  const socket = new WebSocket(url);
  socket.onopen = onopen;
  socket.onclose = onclose;
  socket.onerror = onerror;
  socket.onmessage = onmessage;
  return socket;
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SEND":
      send(state.socket, action.values.jmessage);
      return {
        ...state,
      };
    case "CLOSE":
      state.socket && (state.socket.onclose = () => {});
      state.socket &&
        (state.socket.onmessage = (m) => {
          console.log("Doing nothing with this message ", m);
        });
      send(state.socket, { type: "kill" });
      // state.socket && state.socket.close();
      return {
        ...state,
        socket: undefined,
      };
    case "OPEN":
      state.socket && (state.socket.onclose = () => {});
      state.socket &&
        (state.socket.onmessage = (m) => {
          console.log("Doing nothing with this message state_socket ", m);
        });
      send(state.socket, { type: "kill" });
      // state.socket && state.socket.close();
      // add a brief pause
      const socket = connect(
        action.values.url,
        action.values.onopen,
        action.values.onclose,
        action.values.onerror,
        action.values.onmessage
      );
      return {
        ...state,
        socket: socket,
      };
    case "SET_ONMESSAGE":
      state.socket && (state.socket.onmessage = action.values.onmessage);
      return {
        ...state,
      };
    default: {
      console.log("Websocket default...");
      return state;
    }
  }
};

const useWebsocketState = (state) => {
  const [websocketState, websocketDispatch] = useReducer(reducer, state);
  return { websocketState, websocketDispatch };
};

export default useWebsocketState;
